"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.progress.complete': 'completato',
    'onboarding.progress.steps': 'passi',
};
